import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { Component as ComponentContainer } from '@styles/layout';
import { boxShadowMixins } from '@styles/mixins';
import { Button, ButtonColor, ButtonVariant, ButtonSize } from '@components/material-ui';
import { LazyLoadImage } from '@components/common/lazy-load';
import { useI18NextContext } from '@components/hooks';
import { getImageCdnUrl } from '@util/common';

const Container = styled.div(({ theme }: ThemeProps) => ({
  border: `1px solid ${theme.custom.colors.group10.light}`,
  padding: theme.custom.spacing.large,
  boxShadow: boxShadowMixins(theme.custom.colors.group10.base).default
}));

const Logo: any = styled(LazyLoadImage)({
  maxWidth: 150
});

const Heading = styled.h3(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h3 as any)
}));

const Description = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any)
}));

const ActionButton: any = styled(Button)(({ theme }: ThemeProps) => ({
  width: '100%',
  marginTop: theme.custom.spacing.large
}));

export const CharityTileContainer = () => {
  const t = useI18NextContext();

  const ctaUrl = 'https://www.theirfuturetoday.org';
  const logo = {
    url: '//images.ctfassets.net/3vgdkcmqrnp2/1DUJeysWjz95L4zCekKCt3/153554a264698a67e11fa870af9a1795/c2aba0_bcac975fb7f14595a8fdfc6eefb42f00_mv2.jpg',
    title: t('information__their-future-today--logo-title'),
    height: 120,
    width: 238
  };
  return (
    <ComponentContainer>
      <Container>
        <Logo src={getImageCdnUrl(logo.url)} alt={logo.title} height={logo.height} width={logo.width} />
        <Heading>{t('information__their-future-today--header')}</Heading>
        <Description>{t('information__their-future-today--description')}</Description>
        <ActionButton
          label={t('common__label--view')}
          color={ButtonColor.SECONDARY}
          onClick={() => window.open(ctaUrl)}
          variant={ButtonVariant.OUTLINED}
          size={ButtonSize.SMALL}
        />
      </Container>
    </ComponentContainer>
  );
};
